export default __webpack_public_path__ + "static/media/logo_main.d83c15f3.png";